import api from "../api.service"

export async function createStorageKey(orgId) {
    return api
        .post(`/storageKey`, {
            org: orgId,
        })
        .then((res) => res.data)
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

export async function getStorageKey(keyId) {
    return api
        .get(`/storageKey/${keyId}`)
        .then((res) => res.data)
        .catch((err) => {
            if (!!err?.response) {
                throw err.response
            }
            throw api.getResponseError(err)
        })
}
